import { useState } from "react";
import "./SelectList.css";
import Select from "react-select";

const SelectList = ({
  text,
  color,
  textShadow,
  colorInputText,
  fontWeight,
  fontWeightSingleValue,
  backgroundColor,
  menuPlacement,
  height,
  border,
  options,
  handleChange,
  property,
  valueAux = null,
  edicion,
  emptyInputs,
  isClearable,
}) => {
  return (
    <div className="selectList">
      {text && <label className="title">{text}</label>}
      <Select
        styles={{
          input: (base) => ({
            ...base,
            color: color ? color : colorInputText ? colorInputText : text ? "black" : "white",
            fontWeight: fontWeight ? fontWeight : text ? "bold" : "normal",
            borderRadius: "5px",
            margin: "0px",
            paddingRight: "0.4rem",
            paddingLeft: "0.4rem",
            textShadow: textShadow ? textShadow : "",
          }),
          control: (base) => ({
            ...base,
            borderRadius: border ? 5 : "",
            border: border ? "none" : "",
            boxShadow: border
              ? "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px"
              : "",
            height: height ? height : "",
            backgroundColor: backgroundColor
              ? backgroundColor
              : text
              ? "white"
              : "rgb(248, 176, 61)", // Aquí se aplica el color de fondo al input
          }),
          singleValue: (base) => ({
            ...base,
            color: colorInputText ? colorInputText : text ? "black" : "white",
            fontWeight: fontWeightSingleValue ? fontWeightSingleValue : fontWeight ? fontWeight : text ? "bold" : "normal",
            textShadow: textShadow ? textShadow : ""
          }),
          option: (base) => ({
            ...base,
            fontWeight: fontWeight ? fontWeight : text ? "bold" : "normal",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          clearIndicator: (base, state) => {
            const tieneValorReal = isClearable && state.hasValue && state.getValue()?.[0]?.value !== "";
            return {
              ...base,
              color: tieneValorReal ? "#e53e3e" : base.color,
              "&:hover": {
                color: tieneValorReal ? "#c53030" : base.color,
              },
            };
          },
        }}
        menuPortalTarget={document.body}
        className="inputSelect"
        value={valueAux}
        options={options}
        isDisabled={edicion === "Edicion" ? true : false}
        isClearable={isClearable || false}
        menuPlacement={menuPlacement ? menuPlacement : text ? "bottom" : "top"}
        onChange={(value) => {
          handleChange(value ? { label: value.label, value: value.value } : null);
        }}
        components={{}}
      />
    </div>
  );
};

export default SelectList;